module.exports = __webpack_public_path__ + "img/IMG_3558.1449ec48.jpg";